import { absoluteUrl } from './seo';

export const customerReviews = [
  {
    author: 'Дмитро К.',
    body: 'Замінили екран iPhone в день звернення, дали гарантію і все чітко пояснили по вартості.',
    rating: 5,
    datePublished: '2026-03-15'
  },
  {
    author: 'Анна М.',
    body: 'Після заміни батареї Samsung телефон знову працює цілий день. Сервіс швидкий і ввічливий.',
    rating: 5,
    datePublished: '2026-03-10'
  },
  {
    author: 'Сергій П.',
    body: 'Врятували телефон після води, попередили про ризики і реально відновили дані.',
    rating: 5,
    datePublished: '2026-03-01'
  }
];

export function homeServiceJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Ремонт телефонів у Харкові',
    serviceType: 'Ремонт смартфонів, заміна екрана, заміна батареї та ремонт після води',
    areaServed: 'Харків',
    provider: { '@id': 'https://mobifixpro.net/#business' },
    offers: {
      '@type': 'AggregateOffer',
      priceCurrency: 'UAH',
      lowPrice: '350',
      highPrice: '3500'
    }
  };
}

export function reviewJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    '@id': 'https://mobifixpro.net/#business',
    review: customerReviews.map((review) => ({
      '@type': 'Review',
      author: {
        '@type': 'Person',
        name: review.author
      },
      reviewRating: {
        '@type': 'Rating',
        ratingValue: String(review.rating),
        bestRating: '5'
      },
      reviewBody: review.body,
      datePublished: review.datePublished
    }))
  };
}

export function faqJsonLd(items = []) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((item) => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.a
      }
    }))
  };
}

export function serviceJsonLd({ name, description, path, lowPrice = 350, highPrice = 3500 }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name,
    description,
    areaServed: 'Харків',
    url: absoluteUrl(path),
    image: absoluteUrl('/og-cover.svg'),
    provider: { '@id': 'https://mobifixpro.net/#business' },
    offers: {
      '@type': 'AggregateOffer',
      priceCurrency: 'UAH',
      lowPrice: String(lowPrice),
      highPrice: String(highPrice)
    }
  };
}

export function articleJsonLd(article) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.h1,
    description: article.metaDescription,
    image: absoluteUrl('/og-cover.svg'),
    author: {
      '@type': 'Organization',
      name: 'MobiFIX PRO'
    },
    publisher: {
      '@type': 'Organization',
      name: 'MobiFIX PRO',
      logo: {
        '@type': 'ImageObject',
        url: absoluteUrl('/logo-wordmark.svg')
      }
    },
    mainEntityOfPage: absoluteUrl(article.path),
    datePublished: article.datePublished,
    dateModified: article.datePublished
  };
}

export function breadcrumbJsonLd(items = []) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: absoluteUrl(item.path)
    }))
  };
}
